export default "<payment-partners\n  model=\"vm.model.refuseDebitsAndDepositsPartnerBlacklist\"\n  form=\"vm.form\"\n>\n</payment-partners>\n";